import type { FilterProps } from "_types/filters";
import { Select } from "_ui/Select";
import { useState } from "react";
import { hasPerm } from "_utils/perms";
import { Perms } from "_enums/Perms";
import { Option } from "_types";

export const ViewSelector = ({ current, onChange: _onChange }: FilterProps) => {
    const [value, setValue] = useState(current ?? undefined);

    const options: Option[] = [
        { value: undefined, label: 'Pessoas na fila' },
    ];

    if (hasPerm([Perms.DeskConfView])) {
        options.push({ value: 'my', label: 'Meus atendimentos' });
    }

    if (hasPerm([Perms.DeskConfViewAll])) {
        options.push({ value: 'all', label: 'Todos os atendimentos' });
    }

    const onChange = (newValue) => {
        setValue(newValue);
        _onChange && _onChange(newValue?.value, `${newValue?.label}`);
    }

    return (
        <Select
            isClearable
            placeholder='Pessoas na fila'
            className='w-100'
            value={value}
            onChange={onChange}
            defaultValue={options.find(o => o.value === undefined)}
            {...{ options }}
        />
    );
}
